import { useGeneratePath, useStaticUrls } from 'platform-components';
import React, { useEffect } from 'react';
import { useHistory, useLocation, useParams } from 'react-router';

import { useCalendarPlanQuery } from 'store/calendar-plan/queries';

import { useCurrentGrade } from '../../utils/use-current-grade';

import { CalendarPlanSkeleton } from './_skeleton-view/calendar-plan_skeleton-view';
import { getDefaultTheme } from './utils';

import './calendar-plan-showcase.scss';

interface PathParams {
    classId: string;
    subject: string;
}

export const CalendarPlan = () => {
    const staticUrls = useStaticUrls();
    const history = useHistory();
    const location = useLocation();
    const getRouterPath = useGeneratePath();
    const { classId, subject } = useParams<PathParams>();
    const grade = useCurrentGrade();

    const calendarPlanQuery = useCalendarPlanQuery(subject, grade);
    const calendarPlan = calendarPlanQuery.data;

    useEffect(() => {
        if (calendarPlanQuery.isSuccess) {
            let path = classId ? staticUrls.labLibrarySubject : staticUrls.deepLabLibrary;
            let url = getRouterPath(path);

            if (calendarPlan?.themes_with_periods.length) {
                const calendarPlanTheme = getDefaultTheme(calendarPlan.themes_with_periods);
                path = classId
                    ? staticUrls.labClassLibrarySubjectCalendarPlanTheme
                    : staticUrls.labLibrarySubjectCalendarPlanTheme;
                url = getRouterPath(path, { calendarPlanThemeId: calendarPlanTheme?.theme.id });
            }

            history.replace(`${url}${location.search}`);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [calendarPlan]);

    return <CalendarPlanSkeleton />;
};
